import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import SaudeService from '../../../../../services/saude-auth';
import Profissional from './profissional';
import LocalService from '../../../../../services/local';
import Prof from './prof';


const ListarProfissionais = () => {

    const [profissionais, setProfs] = useState([]);
    const [editar, setEditar] = useState("");
    const [ver, setVer] = useState("");
    const [vazio, setVazio] = useState(false);
    const [profissional, setProf] = useState("");
    const [locais, setLocais] = useState("")


    async function fetchProfissionais() {
        await montaSelectLocais();
        const response = await SaudeService.listarProfissionais();
        if (response.data.length >= 1) {
            setProfs(response.data)
            setVazio(false)
        } else {
            setProfs([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setProf(id);
        setEditar(true)
    }

    const handleVer = (id) => {
        setProf(id);
        setVer(true)
    }

    const montaSelectLocais = async () => {
        const prod = await LocalService.categorias({secretaria: "Secretaria Municipal de Saúde e Prevenção a Dependência Química"});
        setLocais(prod.data)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o profissional?')) {
            await SaudeService.deletarProfissionais(id)
            alert("Profissional deletado com sucesso!")
            fetchProfissionais();
        }
    }

    useEffect(() => {
        fetchProfissionais();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/saude/profissionais/editar/${profissional}`} />
        )
    }else if (ver) {
        return (
            <Fragment>
                <Container>
                    <Prof
                        profissional={profissional}
                        setEditar={setEditar}
                        setVer={setVer}
                        locais={locais}
                    />
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setProfs={setProfs}
                        setVazio={setVazio}
                        fetchProfissionais={fetchProfissionais}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={2}>
                            {profissionais.map((profissional, index) =>
                                <Profissional
                                    fetchProfissionais={fetchProfissionais}
                                    profissional={profissional}
                                    key={index}
                                    editar={handleEditar}
                                    ver={handleVer}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarProfissionais;